import { Component, ViewChild } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { SiteInfoComponent } from '../../components/sites/site-info/site-info.component';
import { SiteConfirmationComponent } from '../../components/sites/site-confirmation/site-confirmation.component';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {NgSelectModule} from "@ng-select/ng-select";

@Component({
    selector: 'app-add-new-site',
    imports: [
        MatButtonModule,
        MatStepperModule,
        FormsModule,
        RouterLink,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        SiteInfoComponent,
        NgSelectModule
    ],
    providers: [ApiService],
    templateUrl: './add-new-site.component.html',
    standalone: true,
    styleUrl: './add-new-site.component.scss'
})
export class AddNewSiteComponent {

  @ViewChild(SiteInfoComponent)
  public SiteInfoComponent!: SiteInfoComponent;

  @ViewChild('stepper') stepper: MatStepper;


  firstFormGroup = this._formBuilder.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required],
  });
  thirdFormGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required],
  });

  fourFormGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required],
  });

  isLinear = false;
  siteId: number;

  constructor(private _formBuilder: FormBuilder, public api: ApiService, private router: Router,
    public toastr: ToastrService, public activeRoute: ActivatedRoute) {

    this.siteId = this.activeRoute.snapshot.params['id'] ? Number(this.activeRoute.snapshot.params['id']) : null;
  }

  ngAfterViewInit(): void {

    if (this.siteId) {
      this.api.getSiteById(this.siteId).subscribe(res => {
        this.SiteInfoComponent.siteForm.patchValue({ ...res.data, countryCode: res.data.country, studies: res.data.studies[0]?.id });
      });
    }

  }



  next() {
    if (this.SiteInfoComponent.siteForm.invalid) {
      this.SiteInfoComponent.errorMessage = true;
      this.toastr.error('Please provide a value for all the required fields');
      this.SiteInfoComponent.siteForm.markAllAsTouched()
    } else {
      this.SiteInfoComponent.getstudyListInfo();
      this.stepper.next();
    }
  }

  onSubmit() {
    if (this.siteId) {
      this.api.putSite({
        "name": this.SiteInfoComponent?.siteForm?.value?.name,
        "address": this.SiteInfoComponent?.siteForm?.value?.address,
        "city": this.SiteInfoComponent?.siteForm?.value?.city,
        "postalCode": this.SiteInfoComponent?.siteForm?.value?.postalCode,
        "countryCode": this.SiteInfoComponent?.siteForm?.value?.countryCode,
        "studies": this.SiteInfoComponent?.siteForm?.value?.studies,
        "siteTeamMembers": this.SiteInfoComponent?.siteForm.value?.members,
        "principalInvestigator": this.SiteInfoComponent?.siteForm.value?.principalInvestigator == null? null : Number(this.SiteInfoComponent?.siteForm.value?.principalInvestigator),
      }, this.siteId).subscribe(res => {
        if (res && res.data) {
          this.router.navigate(['/site-list']);
          this.toastr.success(res?.message, ' ');
        } else {
          this.toastr.error(res.error, ' ');
        }
      }, err => {
        this.toastr.error(err.error.error, ' ');
      });
    } else {
      this.api.postSite({
        "name": this.SiteInfoComponent?.siteForm?.value?.name,
        "address": this.SiteInfoComponent?.siteForm?.value?.address,
        "city": this.SiteInfoComponent?.siteForm?.value?.city,
        "postalCode": this.SiteInfoComponent?.siteForm?.value?.postalCode,
        "countryCode": this.SiteInfoComponent?.siteForm?.value?.countryCode,
        "studies": this.SiteInfoComponent?.siteForm?.value?.studies.map((item) => Number(item)),
        "siteTeamMembers": this.SiteInfoComponent?.siteForm.value?.members.map((item) => Number(item)),
        "principalInvestigator": this.SiteInfoComponent?.siteForm.value?.principalInvestigator == null? null : Number(this.SiteInfoComponent?.siteForm.value?.principalInvestigator),
        "clinicalDevices": [], // TODO Remove when the backend allows it
      }).subscribe(res => {
        if (res && res.data) {
          this.router.navigate(['/site-list']);
          this.toastr.success(res?.message, ' ');
        } else {
          this.toastr.error(res.error, ' ');
        }
      }, err => {
        this.toastr.error(err.error.error, ' ');
      });
    }
  }
}
